import DateFnsUtils from '@date-io/date-fns';
import { makeStyles } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Clear, FilterList } from '@mui/icons-material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Autocomplete, Backdrop, Box, CircularProgress, Grid, IconButton, Stack, TextField, Tooltip, Typography } from '@mui/material';
import Tab from '@mui/material/Tab';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { PuffLoader } from 'react-spinners';
import { UserRole } from '../../models/accesscontrol/AccessContext';
import { IClientUploadCreateAPI, IClientUploadDemographicAPI, IClientUploadUpdateAPI, IGetAPIDocument } from '../../models/APITransationLog/IAPITransationLog';
import { IAdminGetClients } from '../../models/UploadLog/AdminGetClients';
import { useGlobalState } from '../../store/GlobalStore';
import { useFetch, usePost } from '../../utils/apiHelper';
import { useRowStyles } from './APITransactionLogCss';
import DownloadAPIDocument from './DownloadAPIDocument';
import UploadAPIDocument from './UploadAPIDocument';
import UploadCreateAPI from './UploadCreateAPI';
import UploadDemographicAPI from './UploadDemographicAPI';
import UploadUpdateAPI from './UploadUpdateAPI';

const usePopoverStyles = makeStyles({
    paper: {
        border: '2px solid black'
    }
});

const RecordType = [
    { title: 'APMT', value: 'Payment Received By Collection Agency' },
    { title: 'CPMT', value: 'Payment Received By Client' },
    { title: 'NSF', value: 'NSF' },
    { title: 'CBAJ', value: 'Credit Adjustment' },
    { title: 'DBAJ', value: 'Debit Adjustment' },
    { title: 'WOF', value: 'Write Off In Client System' },
    { title: 'CRQ', value: 'Closed Per Client Request' },
    { title: 'LFEE', value: 'Late Fee For The Account' },
    { title: 'REV', value: 'Reversal' }
]

const ApiTransactionLog = () => {
    const classes = useRowStyles();
    const popoverClasses = usePopoverStyles();
    const { state } = useGlobalState();
    const [StartDate, setStartDate] = useState(new Date());
    const [EndDate, setEndDate] = useState(new Date());
    const [clientList, setclientList] = useState<IAdminGetClients[]>([]);
    const clientsLoading = clientList.length === 0;
    const [value, setValue] = React.useState('1');
    const [uploadCreateAPILogList, setUploadCreateAPILogList] = useState<IClientUploadCreateAPI[]>([]);
    const [totalCreateAPICount, setTotalCreateAPICount] = useState<number>(0);
    const [uploadUpdateAPILogList, setUploadUpdateAPILogList] = useState<IClientUploadUpdateAPI[]>([]);
    const [totalUpdateAPICount, setTotalUpdateAPICount] = useState<number>(0);
    const [uploadDemographicAPILogList, setUploadDemographicAPILogList] = useState<IClientUploadDemographicAPI[]>([]);
    const [totalDemographicAPICount, setTotalDemographicAPICount] = useState<number>(0);
    const [SelectClients, setSelectClients] = useState<any>(null);
    const [selectedClient, setSelectedClient] = useState(false);
    const [selectedFirstDate, setSelectedFirstDate] = useState(false);
    const [selectedEndDate, setSelectedEndDate] = useState(false);
    const [ProgressBar, setShowProgressBar] = useState(false);
    const [order, setOrder] = useState<'asc' | 'desc'>('desc');
    const [orderBy, setOrderBy] = useState<string>('CreatedDate');
    const [page, setPage] = useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [selectedRecordType, setSelectedRecordType] = useState<any>(null);

    const handleRecordTypeSelect = (event, value) => {
        setSelectedRecordType(value);
    };

    const handleSortChange = (property: string, direction: 'asc' | 'desc') => {
        setOrder(direction);
        setOrderBy(property);
    };

    const handlePageChange = (newPage: number) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (newRowsPerPage: number) => {
        setRowsPerPage(newRowsPerPage);
        setPage(0);
    };

    let placementMethod = 1;
    if (value == '1') placementMethod = 1;
    else if (value === '2') placementMethod = 2;
    else if (value === '3') placementMethod = 3;

    const DateFormat = state.GlobalUtils?.settingValue === "DD/MM/YYYY" ? "dd/MM/yyyy" : state.GlobalUtils?.settingValue === "MM/DD/YYYY" ? "MM/dd/yyyy" : state.GlobalUtils?.settingValue === "YYYY/MM/DD" ? "yyyy/MM/dd" : "MM/dd/yyyy";

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    const handleFirstDateChange = (date: Date | null) => {
        setStartDate(date);
        setSelectedFirstDate(true);
    };

    const handleEndDateChange = (date: Date | null) => {
        setEndDate(date);
        setSelectedEndDate(true);
    };

    useEffect(() => {
        (async () => {
            if (state?.userAccessContext?.role === 2 || state?.userAccessContext?.role === 3) {
                await useFetch<IAdminGetClients[]>("UploadLog/ClientCodeGetPlacement").then((AdminGetClients) => {
                    setclientList(AdminGetClients?.data);
                });
            }
            else if (state?.userAccessContext?.role === 1) {
                await useFetch<IAdminGetClients[]>(`UploadLog/ClientGetPlacement?userId=${state.userAccessContext?.id}`).then((AdminGetClients) => {
                    setclientList(AdminGetClients?.data);
                });
            }
            else if (state?.userAccessContext?.role === 0) {
                await useFetch<IAdminGetClients[]>(`UploadLog/ClientGetPlacement?userId=${state.userAccessContext?.id}`).then((AdminGetClients) => {
                    setclientList(AdminGetClients?.data);
                });
            }
        })()
    }, [])

    useEffect(() => {
        (async () => {
            await useFetch<IAdminGetClients[]>("UploadLog/ClientCodeGetPlacement").then((AdminGetClients) => {
                setclientList(AdminGetClients?.data);
            });
        });
    }, []);

    useEffect(() => {
        handleFetchAPITransationDetails();
    }, [rowsPerPage, page, orderBy, order, value])

    const handleFetchAPITransationDetails = () => {
        setShowProgressBar(true);
        (async () => {
            const request = {
                "startDate": (selectedFirstDate && StartDate === null ? null : selectedFirstDate ? moment(StartDate).format('YYYY-MM-DD') : null),
                "endDate": (selectedEndDate && EndDate === null ? null : selectedEndDate ? moment(EndDate).format('YYYY-MM-DD') : null),
                "userId": (state?.userAccessContext?.id),
                "roleId": state?.userAccessContext?.role,
                "clientCode": (selectedClient ? (SelectClients === null ? null : SelectClients.client_code) : null),
                "recordType": (selectedRecordType ? (selectedRecordType === null ? null : selectedRecordType) : null),
                "rowsPerPage": rowsPerPage,
                "orderBy": orderBy,
                "orderDirection": order === "desc" ? 1 : 0,
                "startingRecordNumber": page * rowsPerPage,
                "placementMethod": placementMethod,
            }
            await usePost<{
                createTransactionsResult: IClientUploadCreateAPI[], totalCreateAPICount: number, updateTransactionsResult: IClientUploadUpdateAPI[], totalUpdateAPICount: number,
                demographicTransactionsResult: IClientUploadDemographicAPI[], totalDemographicAPICount: number
            }>("History/GetAPITransactionsLog", request).then((result) => {
                if (placementMethod == 1) {
                    setUploadCreateAPILogList(result?.data.createTransactionsResult);
                    setTotalCreateAPICount(result?.data.totalCreateAPICount);
                } else if (placementMethod == 2) {
                    setUploadUpdateAPILogList(result?.data.updateTransactionsResult);
                    setTotalUpdateAPICount(result?.data.totalUpdateAPICount);
                } else if (placementMethod == 3) {
                    setUploadDemographicAPILogList(result?.data.demographicTransactionsResult);
                    setTotalDemographicAPICount(result?.data?.totalDemographicAPICount);
                }
            });
        })().finally(() => {
            setShowProgressBar(false);
        })
    }

    const handleClearAPITransationDetails = () => {
        setShowProgressBar(true);
        (async () => {
            const request = {
                "startDate": null,
                "endDate": null,
                "userId": state?.userAccessContext?.id,
                "roleId": state?.userAccessContext?.role,
                "clientCode": null,
                "recordType": null,
                "rowsPerPage": 100,
                "orderBy": orderBy,
                "orderDirection": order === "desc" ? 1 : 0,
                "startingRecordNumber": 0,
                "placementMethod": placementMethod
            }

            await usePost<{
                createTransactionsResult: IClientUploadCreateAPI[], totalCreateAPICount: number, updateTransactionsResult: IClientUploadUpdateAPI[], totalUpdateAPICount: number,
                demographicTransactionsResult: IClientUploadDemographicAPI[], totalDemographicAPICount: number
            }>("History/GetAPITransactionsLog", request).then((result) => {
                if (placementMethod == 1) {
                    setUploadCreateAPILogList(result?.data.createTransactionsResult);
                    setTotalCreateAPICount(result?.data.totalCreateAPICount);
                } else if (placementMethod == 2) {
                    setUploadUpdateAPILogList(result?.data.updateTransactionsResult);
                    setTotalUpdateAPICount(result?.data.totalUpdateAPICount);
                } else if (placementMethod == 3) {
                    setUploadDemographicAPILogList(result?.data.demographicTransactionsResult);
                    setTotalDemographicAPICount(result?.data?.totalDemographicAPICount);
                }
            });
        })().finally(() => {
            setShowProgressBar(false);
            setStartDate(null);
            setEndDate(null);
            setSelectClients(null);
            setSelectedFirstDate(false);
            setSelectedEndDate(false);
            setSelectedClient(false);
            setSelectedRecordType(null);
        })
    }

    function onClientsSelect(event, value) {
        setSelectedClient(true);
        setSelectClients(value);
        (async () => {
            if (state?.userAccessContext?.role === 2 || state?.userAccessContext?.role === 3) {
                await useFetch<IAdminGetClients[]>("UploadLog/ClientCodeGetPlacement").then((GetAdminClientCodes) => {
                    setclientList(GetAdminClientCodes.data);
                });
            }
            else if (state?.userAccessContext?.role === 1 || state?.userAccessContext?.role === 0) {
                await useFetch<IAdminGetClients[]>(`UploadLog/ClientGetPlacement?userId=${state.userAccessContext?.id}`).then((GetUsersClientCodes) => {
                    setclientList(GetUsersClientCodes?.data);
                });
            }
        })()
    }

    return (
        <React.Fragment>
            <Backdrop className={classes.backdrop} open={ProgressBar}>
                <PuffLoader size={80} color={"white"} speedMultiplier={1} />
            </Backdrop>

            <Box p={1.5}>
                <Grid container spacing={0} boxShadow={"0px 1px 4px 1px rgba(103, 128, 159, 1)"} borderRadius={2}>
                    <Grid item xs={12} sm={12} md={12}>
                        <Grid container spacing={1} >
                            <Grid item xs={6} sm={6} md={value === "2" ? 1.5 : 2}>
                                <Typography variant='body2' align='left' fontSize={"15px"} p={1} pt={2.5} pl={2} color={'primary'}><b>API Transaction Log</b></Typography>
                            </Grid>
                            <Grid item xs={6} sm={6} md={value === "2" ? 2 : 2.5}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        size="small" fullWidth
                                        label="Start Date"
                                        PopoverProps={{ classes: popoverClasses }}
                                        variant="inline"
                                        inputVariant="outlined"
                                        format={DateFormat}
                                        className={classes.textField}
                                        disableToolbar
                                        autoOk={true}
                                        margin="normal"
                                        id="DocUpLog_StartDate"
                                        value={StartDate}
                                        onChange={handleFirstDateChange}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        InputProps={{
                                            classes: {
                                                root: classes.outlinedInput
                                            }
                                        }}
                                        disableFuture={true}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={6} sm={6} md={value === "2" ? 2 : 2.5}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        size="small" fullWidth
                                        label="End Date"
                                        PopoverProps={{ classes: popoverClasses }}
                                        disableToolbar
                                        autoOk={true}
                                        inputVariant="outlined"
                                        variant="inline"
                                        format={DateFormat}
                                        className={classes.textField}
                                        margin="normal"
                                        id="DocUpLog_EndDate"
                                        value={EndDate}
                                        onChange={handleEndDateChange}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        InputProps={{
                                            classes: {
                                                root: classes.outlinedInput
                                            }
                                        }}
                                        disableFuture={true}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={6} sm={6} md={value === "2" ? 2 : 2.5}>
                                <Autocomplete
                                    size="small"
                                    id="DocUpLog_SelectClientCode_DropDown"
                                    autoComplete autoHighlight
                                    classes={{
                                        paper: classes.paper1,
                                        option: classes.autoCompleteFont
                                    }}
                                    className={classes.userdropdown}
                                    options={clientList}
                                    getOptionLabel={(option) => option.client_code}
                                    value={SelectClients}
                                    onChange={onClientsSelect}
                                    loading={clientsLoading}
                                    renderOption={(props, option) => (
                                        <li {...props}>
                                            <Typography variant='body2' ml={"1px"} >
                                                {`${option.client_code} -- ${option.client_name}`}
                                            </Typography>
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Clients"
                                            margin="normal"
                                            variant="outlined"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {clientsLoading ? <CircularProgress size={25} color="inherit" /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }} />
                                    )} />
                            </Grid>
                            {value === "2" && (
                                <Grid item xs={6} sm={6} md={2}>
                                    <Autocomplete
                                        size="small"
                                        id="DocUpLog_SelectRecordType_DropDown"
                                        autoComplete
                                        autoHighlight
                                        classes={{ paper: classes.paper1, option: classes.autoCompleteFont, }}
                                        className={classes.userdropdown}
                                        options={RecordType}
                                        getOptionLabel={(option) => option.title}
                                        value={selectedRecordType}
                                        onChange={handleRecordTypeSelect}
                                        renderOption={(props, option) => (
                                            <li {...props}>
                                                <Typography variant="body2" ml="5px">
                                                    {option.title} -- {option?.value}
                                                </Typography>
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Record Type" margin="normal" variant="outlined" />
                                        )}
                                    />
                                </Grid>
                            )}
                            <Grid item xs={6} sm={6} md={0.7}>
                                <Stack m={0} flexDirection={'row'} justifyContent={'space-evenly'} alignItems={'center'} pt={1.5}>
                                    <Tooltip title="Filters">
                                        <IconButton color="primary" onClick={handleFetchAPITransationDetails}>
                                            <FilterList />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Clear Filters">
                                        <IconButton color="error" onClick={handleClearAPITransationDetails}>
                                            <Clear />
                                        </IconButton>
                                    </Tooltip>
                                </Stack>
                            </Grid>
                            <Grid item xs={6} sm={6} md={1.8}>
                                <Stack m={0} flexDirection={'row'} justifyContent={'space-evenly'} alignItems={'center'} pt={1.5}>
                                    {(state?.userAccessContext?.role === UserRole.SuperAdmin || state?.userAccessContext?.role === UserRole.GlobalAdmin)
                                        ? <UploadAPIDocument />
                                        : <DownloadAPIDocument />
                                    }
                                </Stack>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} borderTop={'1px solid lightgray'}>
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={handleChange} aria-label="lab API tabs example" sx={{ minHeight: '35px !important' }}>
                                    <Tab label={<Typography variant='body2' textTransform={'none'} fontWeight={600}>New Account</Typography>} value="1" sx={{ minHeight: '35px !important' }} />
                                    <Tab label={<Typography variant='body2' textTransform={'none'} fontWeight={600}>Update Account</Typography>} value="2" sx={{ minHeight: '35px !important' }} />
                                    <Tab label={<Typography variant='body2' textTransform={'none'} fontWeight={600}>Demographic Updates</Typography>} value="3" sx={{ minHeight: '35px !important' }} />
                                </TabList>
                            </Box>

                            <TabPanel value="1" sx={{ padding: 0, minHeight: '480px' }}>
                                <UploadCreateAPI uploadCreateAPILogList={uploadCreateAPILogList} totalCreateAPICount={totalCreateAPICount} page={page} order={order}
                                    orderBy={orderBy} onSortChange={handleSortChange} onPageChange={handlePageChange} rowsPerPage={rowsPerPage} onRowsPerPageChange={handleRowsPerPageChange} />
                            </TabPanel>
                            <TabPanel value="2" sx={{ padding: 0, minHeight: '480px' }}>
                                <UploadUpdateAPI uploadUpdateAPILogList={uploadUpdateAPILogList} totalUpdateAPICount={totalUpdateAPICount} page={page} order={order}
                                    orderBy={orderBy} onSortChange={handleSortChange} onPageChange={handlePageChange} rowsPerPage={rowsPerPage} onRowsPerPageChange={handleRowsPerPageChange} />
                            </TabPanel>
                            <TabPanel value="3" sx={{ padding: 0, minHeight: '480px' }}>
                                <UploadDemographicAPI uploadDemographicAPILogList={uploadDemographicAPILogList} totalDemographicAPICount={totalDemographicAPICount} page={page} order={order}
                                    orderBy={orderBy} onSortChange={handleSortChange} onPageChange={handlePageChange} rowsPerPage={rowsPerPage} onRowsPerPageChange={handleRowsPerPageChange} />
                            </TabPanel>
                        </TabContext>
                    </Grid>
                </Grid>
            </Box>
        </React.Fragment>
    )
}

export default ApiTransactionLog